export default __webpack_public_path__ + "static/media/wallets_virt.605c4412.png";